import { useState } from 'react'

function EyeIcon({ off }: { off: boolean }) {
	if (off) {
		return (
			<svg
				viewBox="0 0 24 24"
				fill="none"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			>
				<path d="M10.6 6.2A9.9 9.9 0 0 1 12 6c6.5 0 10 6 10 6a17 17 0 0 1-3.2 3.9M6.6 6.7A17 17 0 0 0 2 12s3.5 6 10 6a9.7 9.7 0 0 0 4.3-1M3 3l18 18" />
				<path d="M9.9 9.9a3 3 0 0 0 4.2 4.2" />
			</svg>
		)
	}
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z" />
			<circle cx="12" cy="12" r="3" />
		</svg>
	)
}

export function MicrosoftMark() {
	return (
		<svg viewBox="0 0 21 21" fill="none" aria-hidden="true">
			<rect x="1" y="1" width="9" height="9" fill="#F25022" />
			<rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
			<rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
			<rect x="11" y="11" width="9" height="9" fill="#FFB900" />
		</svg>
	)
}

export function PasswordField({
	id,
	label,
	value,
	onChange,
	autoComplete,
}: {
	id: string
	label: string
	value: string
	onChange: (value: string) => void
	autoComplete: string
}) {
	const [visible, setVisible] = useState(false)
	return (
		<div className="signin-fld signin-fld--pw">
			<label htmlFor={id}>{label}</label>
			<input
				id={id}
				type={visible ? 'text' : 'password'}
				placeholder="············"
				autoComplete={autoComplete}
				value={value}
				onChange={(e) => onChange(e.target.value)}
			/>
			<button
				className="signin-pw-toggle"
				type="button"
				onClick={() => setVisible((v) => !v)}
				aria-label={visible ? 'Hide password' : 'Show password'}
			>
				<EyeIcon off={visible} />
			</button>
		</div>
	)
}
